var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "80%",
        visible: _vm.visible,
        "before-close": _vm.cancel,
        "close-on-click-modal": false,
        title: _vm.$t("SeaExport.DataComparison")
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "harbour-data-compare" },
        [
          _c(
            "div",
            { staticClass: "harbour-compare-tit" },
            [
              _vm._v(_vm._s(_vm.$t("Message.Explain"))),
              _c("font", { staticClass: "none" }, [
                _vm._v(_vm._s(_vm.$t("Message.BlackIsTheInputData")))
              ]),
              _c("font", { staticClass: "blue" }, [
                _vm._v(_vm._s(_vm.$t("Message.BlueThePortAreaData")))
              ]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("Message.WhenTheBoxIsIdentifiedAsABox")))
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("Message.ClickEnteredDataPleaseOperation"))
                )
              ])
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                "cell-class-name": _vm.cellDisableFunc,
                "row-class-name": _vm.rowClassFunc,
                data: _vm.tableList,
                height: "300px",
                border: "",
                "row-key": "uuid",
                "expand-row-keys": _vm.showExpand
              },
              on: {
                "selection-change": _vm.handleSelect,
                select: _vm.selectData,
                "select-all": _vm.selectAll
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: _vm.selectable,
                  width: "55"
                }
              }),
              _c(
                "el-table-column",
                { attrs: { prop: "type" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("Message.ImportMode")))]),
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: { color: "#1F75D5" },
                      attrs: { title: _vm.$t("Message.ImportDescriptions") }
                    })
                  ])
                ],
                2
              ),
              _c("el-table-column", {
                attrs: {
                  prop: "type",
                  label: _vm.$t("SeaExport.ChargeSource")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.isSystemData
                                  ? _vm.$t("Message.SystemEntry")
                                  : _vm.$t("Message.PortAreaData")
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "containerIdentification",
                  label: _vm.$t("SeaExport.ContainerIdentification")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.children
                                  ? _vm.$t("SeaExport.Box")
                                  : _vm.$t("SeaExport.Cargo")
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "containerNo",
                  label: _vm.$t("Payment.containerNo"),
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.containerNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sealno",
                  label: _vm.$t("SeaExport.SealNo"),
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.sealno))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "soNo",
                  label: _vm.$t("SeaExport.SoNo"),
                  width: "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.soNo))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eqSize",
                  label: _vm.$t("SeaExport.ContainerSize"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.eqSize + "'"))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "eqType",
                  label: _vm.$t("SeaExport.ContainerType"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(_vm.mappingEqType(scope.row)))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "quantity",
                  label: _vm.$t("SeaExport.Quantity"),
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.quantity))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "weight",
                  label: _vm.$t("SeaExport.Weight"),
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.weight))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cubage",
                  label: _vm.$t("SeaExport.Cubage"),
                  width: "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          { class: scope.row.isSystemData ? "none" : "blue" },
                          [_vm._v(_vm._s(scope.row.cubage))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.sumbitHarbour } },
            [_vm._v(_vm._s(_vm.$t("Message.UpdatedToPortAreaData")))]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel2")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }